<template>
    <b-list-group-item :active="confirm ? null : isActive" href="#" @click.prevent="onSelected" class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between align-items-center">
        <template v-if="confirm">
            <div class="align-middle">
                <i class="mr-1 fa-solid fa-star"></i> Delete {{ item?.name }}?
            </div>
            <div class="d-flex">
                <b-button size="sm" variant="danger" class="mr-1" @click.prevent.stop="onCancel"><i class="fa-light fa-xmark align-middle"></i></b-button>
                <b-button size="sm" variant="success" @click.prevent.stop="onConfirmed"><i class="fa-light fa-check align-middle"></i></b-button>
            </div>
        </template>
        <template v-else>
            <div class="align-middle">
                <i class="mr-1 fa-solid fa-star"></i> {{ item?.name }}
            </div>
            <div class="d-flex">
                <b-button size="sm" variant="link" class="ml-3" @click.prevent.stop="onRemoveItem" :class="{'text-light' : isActive}">
                    <i class="fa-solid fa-xmark align-middle"></i>
                </b-button>
            </div>
        </template>
        </div>
    </b-list-group-item>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from 'vuex'
export default FormExtension.extend({
    name: "lab-template-item",
    props: {
        item: {
          type: Object,
          required: true
        },
        isActive: {
          type: Boolean,
          default: false,
        },
    },
    data() {
        return {
            updateItem: false,
            form: new Form({
                name: "",
                consistency_token: null
            }),

            confirm: false
        }
    },
    watch: {
        item: {
            immediate: true,
            handler(val) {
                if(val) {
                    this.form.withData(val)
                }
            }
        },
        updateItem(val) {
            if (!val) {
                this.form.reset()
            }
        }
    },
    methods: {
        onRemoveItem(evt) {
            evt.preventDefault()
            this.confirm = true
        },
        onConfirmed(evt) {
            evt.preventDefault()
            this.$emit('deleted', this.item?.id)
            this.confirm = false
        },
        onCancel(evt) {
            evt.preventDefault()
            this.confirm = false
        },
        onSelected() {
            if(!this.confirm) {
                this.$emit('selected', this.item, this.item?.id)
            }
        }
    }
})
</script>